module.exports = __webpack_public_path__ + "img/hr-dead_mask.5404c9d9.png";